import type { Breadcrumb, ErrorEvent } from "@sentry/nextjs"

// A DSN only permits sending events to this project, so it is public by design.
export const SENTRY_DSN =
  "https://b9009ed85c8a00f2a66d237adbf120f6@o4508885748482048.ingest.us.sentry.io/4512299113971712"

const ENVIRONMENTS = new Map([
  ["playhigherlower.com", "production"],
  ["beta.playhigherlower.com", "staging"],
])

// Local, test and CI hosts have no environment, which keeps Sentry off.
export function getSentryEnvironment(hostname: string | undefined) {
  return hostname ? ENVIRONMENTS.get(hostname) : undefined
}

function stripQuery(url: string) {
  return url.split(/[?#]/, 1)[0]
}

// Keep only the page path and user agent: query strings can carry reset
// tokens or search terms, and headers carry cookies and client addresses.
export function scrubEvent(event: ErrorEvent) {
  const request = event.request
  if (request) {
    const userAgent = Object.entries(request.headers ?? {}).find(
      ([name]) => name.toLowerCase() === "user-agent",
    )
    event.request = {
      method: request.method,
      url: request.url && stripQuery(request.url),
      headers: userAgent ? Object.fromEntries([userAgent]) : undefined,
    }
  }
  return event
}

export function scrubBreadcrumb(breadcrumb: Breadcrumb) {
  if (breadcrumb.category === "console") return null
  const data = breadcrumb.data
  if (data) {
    for (const key of ["url", "from", "to"]) {
      if (typeof data[key] === "string") data[key] = stripQuery(data[key])
    }
  }
  return breadcrumb
}

export function sentryOptions(environment: string) {
  return {
    dsn: SENTRY_DSN,
    environment,
    // SDK 11 replaces sendDefaultPii with these switches. userInfo: false
    // also stops Sentry inferring IP addresses from the ingest request.
    dataCollection: {
      userInfo: false,
      cookies: false,
      urlQueryParams: false,
      httpBodies: [],
    },
    beforeSend: scrubEvent,
    beforeBreadcrumb: scrubBreadcrumb,
  }
}
